import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("zor_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (username, password, remember) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("zor_token", data.token);
    if (remember) localStorage.setItem("zor_user", username);
    setUser(data.user);
  }, []);

  const loginWithGoogle = useCallback(async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    localStorage.setItem("zor_token", data.token);
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("zor_token");
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, loginWithGoogle, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
